<script lang="ts">
    import {PendingPolicy} from "../../models/PendingPolicy";
    import PendingPolicyEdit from "./PendingPolicyEdit.svelte";
    import {updatePendingPolicy} from "../../services/ApplicationDataService";
    import {createEventDispatcher} from "svelte";
    const dispatch = createEventDispatcher();
    export let viewPendingPolicy: PendingPolicy;
    let pendingPolicy = {...viewPendingPolicy};
    let editMode: Boolean = false;
    let buttonText = "Edit my information";
    let pendingForm;
    const togglePendingePolicyEditMode = () => {
        if (editMode) {
            if (!pendingForm.checkValidity()) {
                return false;
            }
            buttonText = 'Edit my information';
            updatePendingPolicy(pendingPolicy);
            pendingPolicy = {...pendingPolicy};
        } else {
            buttonText = 'Close and save my information'
        }
        editMode = !editMode
        dispatch("modeOnChange", editMode);
    }

    $: if (viewPendingPolicy) {
        pendingPolicy = {...viewPendingPolicy};
    }
</script>

<form bind:this={pendingForm}>
    <div class="insured-details info-section">
        <div class="edit-section">
            <h2>Pending Policy</h2>
        </div>
        <hr/>

        {#if !editMode}
            <div class="text-section">
                <div class="text-row">
                    <div class="text-group">
                        <div class="content-text-label">Company Name:</div>
                        <div class="bold-text">{pendingPolicy.companyName || ''} </div>
                    </div>
                </div>
                <div class="text-row">
                    <div class="text-group">
                        <div class="content-text-label">Amount of Coverage:</div>
                        <div class="bold-text">{pendingPolicy.amountOfCoverage || ''} </div>
                    </div>
                </div>
                <div class="text-row">
                    <div class="text-group">
                        <div class="content-text-label">Purpose of Coverage:</div>
                        <div class="bold-text">{pendingPolicy.purposeOfCoverage || ''} </div>
                    </div>
                </div>


            </div>
        {/if}

        {#if editMode}
            <PendingPolicyEdit pendingPolicy={pendingPolicy}/>
        {/if}

        <div>
            <button on:click={togglePendingePolicyEditMode} class="card-link buttonWithoutBorder"
                    type="button">{buttonText}</button>
        </div>
    </div>
</form>
<style lang="scss">
  @use "../../../component_scss_library/layout" as layout;
  @use "../../../component_scss_library/buttons" as buttons;


</style>
